import React, {useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {EvaArrowIosBackFill} from './icons/BackButton'
import ReactDatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css' // Make sure you have the CSS file imported
import MarketingService from '../../../api/MarketingService'
import {toast} from 'react-toastify'

export default function ConfirmationCampaignPeriod() {
  let navigate = useNavigate()
  const location = useLocation()
  const {description, route, title, ids, message, reception_type} = location.state || {}

  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [selectedTime, setSelectedTime] = useState(null)
  const [selectedTimeError, setSelectedTimeError] = useState(false)
  const [startDateError, setStartDateError] = useState(false)
  const [endDateError, setEndDateError] = useState(false)
  const minDate = new Date()
  minDate.setDate(minDate.getDate() + 1) // Set minDate to tomorrow
  // minDate.setDate(minDate.getDate() + 1) // Set minDate to tomorrow
  const handleFormSubmit = (e) => {
    e.preventDefault()
    if (!startDate) {
      setStartDateError(true)
    }
    if (!endDate) {
      setEndDateError(true)
    }
    if (startDate && endDate) {
      const datesArray = []
      const currentDate = new Date(startDate)

      while (currentDate <= endDate) {
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so add 1
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        datesArray.push(formattedDate)
        currentDate.setDate(currentDate.getDate() + 1)
      }

      // Check if other required data is present
      let data = {
        description,
        route,
        title,
        ids,
        message,
        reception_type,
        date: datesArray,
        time: selectedTime
          ? selectedTime.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', hour12: false})
          : '00:00',
      }
     

      MarketingService.addCampaign(data).then(
        (res) => {
          if (res?.data?.success) {
            toast.success(res?.data?.message, {theme: 'dark'})
            navigate('/campaign/confirmation', {
              state: {
                startDate: startDate?.toISOString()?.split('T')[0],
                endDate: endDate?.toISOString()?.split('T')[0],
                time: selectedTime
                ? selectedTime.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', hour12: false})
                : '00:00',
              },
            })
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err) => {
          toast.error(err?.response?.data?.message, {theme: 'dark'})
        }
      )
    }
  }

/*************  ✨ Codeium Command ⭐  *************/
  /**
   * Set the start date to the given date, and reset the start date error if the given date is valid.
   * @param {Date} date The date to set as the start date.
   */
/******  b91a8aca-1f8a-4008-b0e9-0669506ade21  *******/
  const handleStartDateChange = (date) => {
    setStartDate(date)
    if (date) {
      setStartDateError(false)
    }
  }

  const handleEndDateChange = (date) => {
    setEndDate(date)
    if (date) {
      setEndDateError(false)
    }
  }
  const handleSelectedTimeChange = (date) => {
    if (date) {
      setSelectedTime(date)
      setSelectedTimeError(false)
    } else {
      setSelectedTime(null)
      setSelectedTimeError(true)
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          cursor: 'pointer',
          alignContent: 'center',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
        onClick={() => navigate(-1)}
      >
        <div style={{padding: 5, backgroundColor: 'white', borderRadius: 100, marginRight: 5}}>
          <EvaArrowIosBackFill />
        </div>
        <p style={{fontSize: 14, fontWeight: 'bold', margin: 0}}>Back</p>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          paddingRight: 30,
          paddingLeft: 50,
          marginTop: 20,
        }}
      >
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#B0B0B0',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            1
          </p>
          <p style={{fontSize: 14, marginLeft: 5, color: '#B0B0B0'}}>Create Campaign</p>
        </div>

        <hr style={{width: 170, marginLeft: 5, marginRight: 5, color: '#B0B0B0'}} />
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#B0B0B0',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            2
          </p>
          <p style={{fontSize: 14, marginLeft: 5}}>Select Recipients</p>
        </div>

        <hr style={{width: 170, marginLeft: 5, marginRight: 5}} />
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#2ABD84',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            3
          </p>
          <p style={{fontSize: 14, marginLeft: 5, color: '#2ABD84'}}>campaign periods</p>
        </div>

        <hr style={{width: 170, marginLeft: 5, marginRight: 5, color: '#2ABD84'}} />
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#B0B0B0',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            4
          </p>
          <p style={{fontSize: 14, marginLeft: 5}}>Confirm</p>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'row',
          marginRight: 30,
          marginLeft: 30,
          marginTop: 10,
          backgroundColor: 'white',
          paddingRight: 30,
          paddingLeft: 30,
          paddingTop: 60,
          paddingBottom: 60,
          borderRadius: 10,
        }}
      >
        <div className='col-lg-6 col-12 mb-10'>
          <div style={{padding: 20}}>
            <h2 style={{fontSize: 32, color: '#736F6F', marginBottom: 20}}>
              Confirmation campaign Period
            </h2>
            <p style={{fontSize: 16, color: '#898484'}}>
              Confirm the schedule date and time your campaign should begin
            </p>
            <p style={{fontSize: 16, color: '#898484', textAlign: 'justify'}}>
              Select a <strong>start date</strong> to initiate campaign and{' '}
              <strong>end date</strong> when campaign will end. This will allow messages to be sent
              on a sprint on selected days. e.g 01/01/23 to 06/01/23
            </p>
            <p style={{fontSize: 16, color: '#898484', textAlign: 'justify'}}>
              <strong>Customize date</strong> is basically on a specific date{' '}
              <strong>01/06/23, 01/08/23,02/07/23</strong>
            </p>
          </div>
        </div>
        <div className='col-lg-6 col-12'>
          <form onSubmit={handleFormSubmit}>
            <div className='form-group mb-3'>
              <label style={{color: '#4A4747', fontSize: 16}}>Start Date</label>
              <ReactDatePicker
                className={`form-control ${startDateError ? 'is-invalid' : ''}`}
                selected={startDate}
                onChange={handleStartDateChange}
                dateFormat='yyyy-MM-dd'
                placeholderText='Select Scheduled Interval'
                showYearDropdown={false}
                scrollableYearDropdown
                minDate={minDate} // Disable today's and previous dates
              />
              {startDateError && <div className='invalid-feedback'>Start date is required.</div>}
            </div>
            <div className='form-group mb-3'>
              <label style={{color: '#4A4747', fontSize: 16}}>End Date</label>
              <ReactDatePicker
                className={`form-control ${endDateError ? 'is-invalid' : ''}`}
                selected={endDate}
                onChange={handleEndDateChange}
                dateFormat='yyyy-MM-dd'
                placeholderText='Select Date of interval'
                showYearDropdown={false}
                scrollableYearDropdown
                minDate={minDate} // Disable today's and previous dates
              />
              {endDateError && <div className='invalid-feedback'>End date is required.</div>}
            </div>
            <div className='form-group mb-3'>
              <label style={{color: '#4A4747', fontSize: 16}}>Select Time</label>
              <ReactDatePicker
                className={`form-control ${selectedTimeError ? 'is-invalid' : ''}`}
                selected={selectedTime}
                onChange={handleSelectedTimeChange}
                placeholderText='Select Time'
                showTimeSelectOnly
                showTimeSelect
                timeFormat='HH:mm'
                timeIntervals={60}
                dateFormat='HH:mm'
              />
              {selectedTimeError && <div className='invalid-feedback'>Time is required.</div>}
            </div>

            <div className='d-flex justify-content-end mt-3'>
              <button
                onClick={() =>
                  navigate('/campaign/customized-date', {
                    state: {
                      description,
                      route,
                      title,
                      ids,
                      message,
                      reception_type,
                      time: selectedTime,
                    },
                  })
                }
                className='btn'
                style={{
                  marginTop: 10,
                  color: '#2ABD84',
                }}
              >
                Customize dates
              </button>
            </div>
            <div className='d-flex justify-content-end mt-3'>
              <button
                type='submit'
                className='btn'
                style={{
                  padding: '10px 70px',
                  borderRadius: 20,
                  backgroundColor: '#00B649',
                  color: 'white',
                  marginTop: 50,
                }}
                disabled={!startDate || !endDate || !selectedTime}
              >
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}
